import { P3, styled, withStyle } from '@olxeu-jobs/ui';
import { Platform } from '~types';

export const CarouselWrapper = styled('section', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.space[12],

  [$theme.mediaQuery.md]: {
    gap: $theme.space[16],
  },
}));

export const CarouselHeadingContainer = styled('div', ({ $theme }) => ({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'space-between',
  ...($theme.platform === Platform.DESKTOP && {
    justifyContent: 'initial',
  }),
}));

export const CarouselHeading = styled('h2', ({ $theme }) => ({
  ...$theme.typography.h4,
  marginTop: 0,
  marginBottom: 0,
  ...($theme.platform === Platform.DESKTOP && {
    ...$theme.typography.h3,
  }),
}));

export const LinkParagraph = withStyle(P3, ({ $theme }) => ({
  marginLeft: 'auto',
  whiteSpace: 'nowrap',
  marginTop: 0,
  marginBottom: 0,
  [$theme.mediaQuery.md]: {
    marginLeft: $theme.space[16],
  },
}));

export const CarouselHeaderWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const SkeletonWrapper = styled('div', ({ $theme }) => ({
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'row',
  paddingLeft: 0,
  marginTop: 0,
  marginBottom: 0,
  gap: $theme.space[8],
}));
